import React from 'react';

const PawIcon = () => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3585 5.9338C12.9942 5.78817 12.5769 5.87075 12.1589 6.12776C11.7733 6.37289 11.4851 6.75665 11.2682 7.21882C10.8275 8.21534 11.0318 9.22015 11.7471 9.48124C11.8837 9.53584 12.0074 9.5604 12.1509 9.54276C12.7829 9.52097 13.4628 8.99427 13.8247 8.16588C14.2781 7.19966 14.0741 6.19482 13.3585 5.93376L13.3585 5.9338Z"
        fill="#7A8591"
      />
      <path
        d="M3.63466 9.72717C3.77794 9.70962 3.88899 9.70406 4.0194 9.65647C4.72432 9.36448 4.898 8.36091 4.42658 7.3492C4.20053 6.90952 3.8763 6.50542 3.4863 6.29975C3.07045 6.03377 2.63413 5.98415 2.2881 6.14515C1.58318 6.43714 1.4095 7.44071 1.88091 8.45242C2.31445 9.19942 2.98976 9.71896 3.63467 9.72721L3.63466 9.72717Z"
        fill="#7A8591"
      />
      <path
        d="M9.53274 7.12149C9.61093 7.12769 9.68898 7.13418 9.73462 7.15225C10.1451 7.14161 10.5436 6.92673 10.8772 6.56112C11.2633 6.14164 11.5394 5.55344 11.6465 4.92247C11.9195 3.53463 11.4033 2.33015 10.4398 2.19434C9.50876 2.04667 8.56639 3.01719 8.29326 4.40531C8.15369 5.04813 8.23568 5.67978 8.4096 6.17346C8.67467 6.70358 9.05103 7.05368 9.53278 7.12147L9.53274 7.12149Z"
        fill="#7A8591"
      />
      <path
        d="M5.95062 7.21123C6.02881 7.21742 6.0939 7.19367 6.17218 7.20008C6.62223 7.10553 7.00159 6.75821 7.21242 6.19383C7.40356 5.67137 7.39962 5.04621 7.27219 4.39635C6.94592 3.01837 5.9789 2.08282 5.06616 2.24177C4.12064 2.4127 3.67238 3.65564 3.96623 5.04571C4.1264 5.68356 4.40412 6.24381 4.80631 6.65419C5.15004 7.01594 5.57261 7.20979 5.9506 7.21124L5.95062 7.21123Z"
        fill="#7A8591"
      />
      <path
        d="M9.82074 8.13244C9.74949 8.054 9.01558 7.48613 8.41018 7.39377C8.2083 7.36301 8.05206 7.35032 7.92836 7.32576C7.88295 7.3076 7.85017 7.31956 7.81763 7.33144C7.7069 7.33712 7.53075 7.36643 7.32216 7.40783C6.72883 7.51992 6.00969 8.13066 5.92444 8.1965L4.51001 9.82676C3.79679 10.5398 3.50713 11.2721 3.59508 12.006C3.77887 13.2272 5.11125 13.9596 5.15693 13.9777C5.69647 14.2682 6.22389 14.3543 6.63443 14.3437C7.26646 14.3219 7.74314 14.1132 7.95845 13.9997C8.34856 14.2056 9.47381 14.6304 10.7735 13.8775C10.8388 13.8537 12.093 13.0827 12.2415 11.8447C12.3424 11.1116 12.0001 10.4007 11.28 9.68871L9.82074 8.13244Z"
        fill="#7A8591"
      />
    </svg>
  );
};

export default PawIcon;
